import { useContext as u, useEffect as a, useMemo as c } from "react";
import { N as f } from "../../../LoadingSuspense-BdXYIsHy.js";
const w = (e) => {
  const r = u(f);
  if (r === void 0)
    throw new Error("useToaster must be used within a IressToasterProvider");
  const { show: t, setOptions: i, options: o, animateOut: n } = r;
  return a(() => {
    e && i({
      ...o,
      position: e ?? o.position
    });
  }, [e]), c(
    () => ({
      success: (s) => t({ ...s, status: "success" }),
      error: (s) => t({ ...s, status: "error" }),
      info: (s) => t({ ...s, status: "info" }),
      close: n,
      options: o
    }),
    [n, o, t]
  );
};
export {
  w as useToaster
};
